import { SimpleTokenDto } from '../dto';
import { SimpleToken } from '../model';
import { ChainFactory } from './chain.factory';
import { TagFactory } from './tag.factory';

export class SimpleTokenFactory {
  public static createFromDto(dto: SimpleTokenDto): SimpleToken {
    const simpleToken = new SimpleToken();

    if (dto) {
      simpleToken.address = dto.address;
      simpleToken.name = dto.name;
      simpleToken.symbol = dto.symbol;
      simpleToken.imageUrl = dto.imageUrl;
      simpleToken.decimals = dto.decimals;
      simpleToken.sliderColor = dto.sliderColor;
      simpleToken.deflationary = dto.deflationary;
      simpleToken.automationEnabled = dto.automationEnabled;
      if (dto.chain) {
        simpleToken.chain = ChainFactory.createChainFromDto(dto.chain);
      }
      if (dto.tags) {
        simpleToken.tags = TagFactory.createFromDtos(dto.tags);
      }
    }

    return simpleToken;
  }
}
